module.exports = __webpack_public_path__ + "static/media/author8.35f49d93.jpg";